<template>
	<div class="block xs-12">
		<!-- English First Name -->
		<core-form-input
			componentName="j-base-input-text"
			name="firstName"
			:label="$t('english_first_name')"
			v-validate="'required'"
			v-model="form.englishFirstName"
			:validationErrors="errors"
		/>

		<!-- English Last Name -->
		<core-form-input
			class="mt6"
			componentName="j-base-input-text"
			name="lastName"
			:label="$t('english_last_name')"
			v-validate="'required'"
			v-model="form.englishLastName"
			:validationErrors="errors"
		/>

		<!-- Chinese First Name -->
		<core-form-input
			class="mt6"
			componentName="j-base-input-text"
			name="chineseFirstName"
			:label="$t('chinese_first_name')"
			v-model="form.chineseFirstName"
		/>

		<!-- Chinese Last Name -->
		<core-form-input
			class="mt6"
			componentName="j-base-input-text"
			name="chineseLastName"
			:label="$t('chinese_last_name')"
			v-model="form.chineseLastName"
		/>

		<!-- Email -->
		<core-form-input
			class="mt6"
			componentName="j-base-input-text"
			name="email"
			v-validate="'email'"
			:validationErrors="errors"
			:label="$t('email')"
			v-model="form.email"
		/>

		<!-- Code -->
		<core-form-input
			class="mt6"
			:description="$t('internal_code_description')"
			componentName="j-base-input-text"
			name="code"
			:label="$t('code')"
			v-model="form.internalCode"
		/>

		<!-- isActive -->
		<core-form-input
			class="mt6"
			componentName="j-base-toggle"
			name="isActive"
			:label="$t('active_referral')"
			v-model="form.isActive"
		/>

		<!-- Actions slot for buttons -->
		<slot name="actions" :onSubmit="onSubmit"></slot>
	</div>
</template>

<script>
/**
 * This component is responsible for rendering of fields for creation and update of internals
 */

import CoreFormInput from "@/modules/core/components/CoreFormInput"

export default {
	components: { CoreFormInput },

	props: {
		data: {
			type: Object,
			required: false,
			default: () => ({
				englishFirstName: null,
				englishLastName: null,
				chineseFirstName: null,
				chineseLastName: null,
				email: null,
				emailId: null,
				internalCode: null,
				isActive: true
			})
		}
	},

	data() {
		return {
			form: {
				englishFirstName: null,
				englishLastName: null,
				chineseFirstName: null,
				chineseLastName: null,
				email: null,
				emailId: null,
				internalCode: null,
				isActive: null
			}
		}
	},

	methods: {
		/**
		 * When form is valid this method emits input event with this.form as payload
		 */
		async onSubmit() {
			const isValid = await this.$validator.validate()
			if (!isValid) return

			this.$emit("input", this.form)
		}
	},

	watch: {
		/**
		 * TODO: come up with better approach than watcher?
		 * When data is passed as prop, it will populate internal state form
		 */
		data: {
			handler() {
				this.form = { ...this.data }
			},
			immediate: true,
			deep: true
		}
	}
}
</script>
